// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3_kR2","alert":"SettungsInbox_alert__2rumO"};